var pdfjsLib = require("pdf_js");
require("pdf_js_worker");
require("pdf_js_worker_entry");

const scanForPdfNotes = () => {
    $(".pdfViewer").each((i, pdfWrapperElm) => {
        const pdfWrapper = $(pdfWrapperElm);

        let pageRendering = false;
        let pdfDoc = null;

        const spinnerElm = pdfWrapper.find(".pdf-spinner-container")[0];
        const continuousContainer = pdfWrapper.find(".pdfContent")[0];

        const pdfUrl = pdfWrapperElm.dataset.pdfUrl;
        const documentId = pdfWrapperElm.dataset.documentId;

        const renderAllPages = () => {
            pageRendering = true;
            continuousContainer.innerHTML = '';
            for (let i = 1; i <= pdfDoc.numPages; i++) {
                const pageCanvas = document.createElement('canvas');
                pageCanvas.className = 'pdfCanvas';
                pageCanvas.style.display = 'block';
                continuousContainer.appendChild(pageCanvas);

                const textLayerDiv = document.createElement('div');
                textLayerDiv.className = 'textLayer';
                continuousContainer.appendChild(textLayerDiv);

                pdfDoc.getPage(i).then((page) => {
                    const viewport = page.getViewport({scale: 2});
                    pageCanvas.height = viewport.height;
                    pageCanvas.width = viewport.width;

                    const renderContext = {
                        canvasContext: pageCanvas.getContext('2d'),
                        viewport: viewport
                    };

                    page.render(renderContext).promise.then(() => {
                        if (i === pdfDoc.numPages) {
                            pageRendering = false;
                        }

                        return page.getTextContent();
                    }).then((textContent) => {
                        textLayerDiv.innerHTML = '';
                        textLayerDiv.style.left = `${pageCanvas.offsetLeft}px`;
                        textLayerDiv.style.top = `${pageCanvas.offsetTop}px`;

                        const actualScale = 2 * pageCanvas.offsetWidth / viewport.width;
                        const textLayerViewport = page.getViewport({scale: actualScale});

                        updateRerenderCondition(pageCanvas.offsetWidth);

                        pdfjsLib.renderTextLayer({
                            textContent: textContent,
                            container: textLayerDiv,
                            viewport: textLayerViewport,
                            textDivs: []
                        });
                    });
                });
            }
        };
        const loadPdf = () => {
            pdfjsLib.getDocument(pdfUrl).promise.then((pdfDoc_) => {
                pdfDoc = pdfDoc_;
                renderAllPages();
                removeSpinnerAndShowCanvas();
            }).catch(() => {
                const pdfLinkId = `#pdf-link${documentId}`;
                $(pdfLinkId).remove();
            });
        }

        const removeSpinnerAndShowCanvas = () => {
            pdfWrapper.show();
            $(spinnerElm).hide();
        }

        const updateRerenderCondition = (currentPageWidth) => {
            $(window).resize(()=> {
                const canvasWidth = pdfWrapper.find(".pdfCanvas")[0].offsetWidth;

                if (canvasWidth !== currentPageWidth && !pageRendering) {
                    renderAllPages();
                }
            });
        }

        new MutationObserver((mutations) => {
            for (let index = 0; index < mutations.length; index++) {
                const mutation = mutations[index];
                if (mutation.type === "attributes" && mutation.attributeName === "class" && mutation.target.classList.contains("isVisible")) {
                    loadPdf();
                }
            }
        }).observe(pdfWrapper.parents(".punktrow")[0], {
            attributes: true
        });
    });
}

document.scanForPdfNotes = scanForPdfNotes;



//////////////////
// WEBPACK FOOTER
// ./Content/scripts/pdfViewer.js
// module id = 148
// module chunks = 4